import { useMediaQuery } from "@mui/material"
import DerivativeWeb from "./DerivativeWeb"
import DerivativeMob from "./DerivativeMob"
export default function Equity() {
    const isSmallScreen = useMediaQuery("(max-width:800px)");
    return isSmallScreen ? <DerivativeMob /> : <DerivativeWeb />;

}